import React, { Component, Fragment } from 'react'
import { withTranslation } from 'react-i18next'
import _ from 'lodash'
import { isSafari } from 'react-device-detect'
import moment from 'moment'
import {
  Button,
  Row,
  Col,
  Tabs,
  Input,
  List,
  Avatar,
  Tooltip,
  Select,
  Modal,
  Form,
  InputNumber,
  Card,
  Popover
} from 'antd'
import { PlayCircleOutlined, CloseOutlined } from '@ant-design/icons'
import { activateSoundIcon, deactiveSoundIcon } from '../../../images'
import { AudioPlayer } from '../../../components'
import { saveBase64AsAudioFile } from '../../../../../../../../../../utils'
import './CreateAudio.scss'
import Autocomplete from 'react-autocomplete'
import styles from './CreateAudio.style'
import { translationKeys } from '../../../../../../../../../../constants'
import { api } from '../../../../../../../../../../services'
import TextLibrary from '../../../../../../../../../../components/Builder/Elements/Text/internal/TextLibrary'
import {
  textIconInsideRectangle,
  textIconRectangle
} from '../../../../Text/images'

const { TabPane } = Tabs
const { TextArea } = Input
const { Option } = Select

const styleTitle = { color: 'rgb(103, 104, 108)', fontWeight: 'normal' }

class CreateAudio extends Component {
  state = {
    src: '',
    voiceList: [],
    selectedText: '',
    languageValue: '',
    languages: [],
    filteredList: [],
    selectedVoice: '',
    autoPlay: false,
    lang: '',
    showTextModal: false,
    isInsertText: false,
    selectedTextViewer: '',
    showSearchResult: false,
    isLoading: false,
    resultData: [],
    hasInitialize: true,
    hasSummarizeInitialize: false,
    loadSummarize: false,
    errorMsg: '',
    sampleSrc: '',
    summariseResultOptionOne: [],
    summariseResult: [],
    scheduleTime: null
  }

  componentDidMount() {
    const { listTTSVoices, text, user } = this.props

    this.setState({ selectedText: text })
    listTTSVoices().then(res => {
      if (res) {
        this.updateVoiceList(res.data)
      }
    })
    api.user.getScheduleTime().then(res => {
      this.setState({
        ...this.state,
        scheduleTime: res.data
      })
      const currentTime = moment()
      // const scheduleTime = moment.unix(res.data.schedule).add(10, 'minutes')
      const scheduleTime = moment.unix(res.data.schedule)
      const scheduleTimeAfterDur = moment(
        scheduleTime.valueOf() + res.data.ttl * 60000
      )
      const enableAi = user.info.organization.enable_ai
      console.log(
        enableAi,
        scheduleTime.isAfter(currentTime),
        scheduleTimeAfterDur.isBefore(currentTime),
        scheduleTime.isAfter(currentTime) &&
          !scheduleTimeAfterDur.isBefore(currentTime),
        'check'
      )
      if (enableAi) {
        if (
          scheduleTime.isAfter(currentTime) &&
          !scheduleTimeAfterDur.isBefore(currentTime)
        ) {
          this.audioInterval = setInterval(() => {
            this.audioPremiumTalen6()
          }, 30000)
        }
      }
    })
  }

  audioPremiumTalen6 = () => {
    api.audioSynthesizer.getNewAudioAdminRes().then(res => {
      if (res.status === 200) {
        clearInterval(this.audioInterval)
        let newdata = [
          Object.keys(res.data.data)[0],
          {
            gender: res.data.data.talen6.gender,
            language: res.data.data.talen6.language,
            locale: res.data.data.talen6.locale,
            neural: true,
            sample: res.data.data.talen6.sample
          }
        ]
        this.setState({
          ...this.state,
          voiceList: [newdata, ...this.state.voiceList]
        })
      }
    })
  }

  handleChangeOption = e => {
    this.setState(
      {
        lang: e
      },
      () => {
        const { selectedText } = this.state
        if (selectedText === '') {
          return
        }
        const temp = {
          text: selectedText
        }
        this.setState({
          selectedText: 'Please wait... preparing translation'
        })
        api.audioSynthesizer
          .textTranslate(temp)
          .then(res => {
            if (res.data && res.data.result) {
              const tempVar = {
                text: selectedText,
                source_language: res.data.data,
                language: e
              }
              this.setState({
                selectedText: 'Please wait... translating'
              })
              api.audioSynthesizer
                .textTranslate(tempVar)
                .then(res => {
                  this.setState({
                    selectedText: res.data.data
                  })
                })
                .catch(() => {
                  this.setState({
                    selectedText: ''
                  })
                })
            }
          })
          .catch(() => {
            this.setState({
              selectedText: ''
            })
          })
      }
    )
  }

  updateVoiceList = data => {
    const voiceArr = Object.entries(data)
    const values = Object.values(data)
    const allLanguage = values.map(t => {
      return t.language
    })
    const languages = allLanguage.reduce((all, item) => {
      return all.includes(item) ? all : [...all, item]
    }, [])

    this.setState({
      voiceList: [...this.state.voiceList, ...voiceArr],
      languages
    })
  }

  onChangeText = e => {
    this.setState({
      src: '',
      autoPlay: false,
      selectedText: e.target.value
    })
  }

  onClickCard = value => {
    this.setState({
      src: '',
      autoPlay: false,
      selectedVoice: value[0]
    })
  }

  postTTS = (txt, type) => {
    const { postTTSVoices } = this.props
    const { selectedVoice } = this.state
    postTTSVoices({
      voice: selectedVoice,
      text: txt
    }).then(data => {
      if (data && data.result) {
        if (type === 'preview') {
          this.setState({
            sampleSrc:
              'data:' + data.data.mimetype + ';base64,' + data.data.audio
          })
          return
        }
        this.setState({
          src: 'data:' + data.data.mimetype + ';base64,' + data.data.audio
        })
      }
    })
  }

  onClickButton = async () => {
    const { onShowDetailModal } = this.props
    const { src, selectedText, selectedVoice } = this.state
    if (selectedVoice === 'talen6') {
      if (!_.isEmpty(src)) {
        let filename = `${'voiceover' +
          Math.floor(1000 + Math.random() * 9000)}.mp3`
        const response = await fetch(src, { mode: 'cors' })
        const blob = await response.blob()
        const file = new File([blob], filename, { type: blob.type })
        onShowDetailModal(file, selectedText)
        return
      }
      try {
        const res = await api.audioSynthesizer.postNewAudioAdminRes({
          text: selectedText
        })
        const srcurl = res.data.s3_presigned_url
        this.setState({
          ...this.state,
          autoPlay: true,
          src: srcurl
        })
      } catch (err) {}
      return
    }
    if (!_.isEmpty(src)) {
      let block = src.split(';')
      let dataType = block[0].split(':')[1]
      let data = block[1].split(',')[1]
      let filename = `${'voiceover' +
        Math.floor(
          1000 + Math.random() * 9000
        )}.mp3` /* @TODO Update logic later */
      let mp3File = saveBase64AsAudioFile(filename, data, dataType)
      onShowDetailModal(mp3File, selectedText)
      return
    }
    this.setState(
      {
        sampleSrc: ''
      },
      () => {
        this.postTTS(selectedText, 'create')
      }
    )
  }

  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        console.log('Received values of form: ', values)
        this.setState({
          ...this.state,
          isLoading: true,
          showSearchResult: false,
          resultData: [],
          summariseResultOptionOne: [],
          summariseResult: []
        })

        const {
          info: { active_organization_id }
        } = this.props.user

        const temp = {
          question: values.question,
          no_of_documents: String(values.no_of_documents),
          org_id: String(active_organization_id)
        }

        api.audioSynthesizer
          .questionBot(temp)
          .then(res => {
            console.log('response question bot', res.data.body)
            if (res.data.body) {
              this.setState({
                ...this.state,
                showSearchResult: true,
                isLoading: false,
                resultData: res.data.body
              })
            }
          })
          .catch(err => {
            console.log('error in starting event', err)
            this.setState({
              ...this.state,
              showSearchResult: false,
              isLoading: false,
              resultData: []
            })
          })
      }
    })
  }

  onClickPreviewIcon = async value => {
    console.log('scrom', 'samefile')
    if (value[0] === 'talen6') {
      this.setState({
        ...this.state,
        src: '',
        autoPlay: true,
        selectedVoice: value[0],
        sampleSrc: '',
        audioprevLoading: true
      })
      const res = await api.audioSynthesizer.postNewAudioAdminRes({
        text: value[1].sample
      })
      const srcurl = res.data.s3_presigned_url
      this.setState({
        ...this.state,
        autoPlay: true,
        selectedVoice: value[0],
        sampleSrc: srcurl
      })
      return
    }
    const sample = value[1].sample
    this.setState(
      {
        src: '',
        autoPlay: true,
        selectedVoice: value[0],
        sampleSrc: ''
        // selectedText: value[1].sample
      },
      () => {
        this.postTTS(sample, 'preview')
      }
    )
  }

  handleClickImportText = () => {
    const { showTextModal } = this.props
    showTextModal({ isShowTextModal: true })
  }

  onLanguageSearch = e => {
    this.setState({ languageValue: e })
  }

  onCloseTextViewer = () => {
    this.setState({ selectedTextViewer: '' })
  }

  onLanguageSelect = value => {
    const { voiceList } = this.state
    const arr = []
    voiceList.forEach(v => {
      if (v[1].language === value) {
        arr.push(v)
      }
    })
    this.setState({ languageValue: value, filteredList: arr })
  }

  onHideTextModal = () => {
    const { showTextModal } = this.props
    showTextModal({ isShowTextModal: false })
  }

  showText = val => {
    this.setState({
      selectedTextViewer: val
    })
  }

  handleInsertText = () => {
    this.setState(
      {
        isInsertText: true
      },
      () => {
        const { showTextModal } = this.props
        showTextModal({ isShowTextModal: false })
      }
    )
  }

  handleClickQAText = () => {
    this.setState(prevState => ({
      ...this.state,
      isWideView: !prevState.isWideView,
      showSearchResult: false,
      isLoading: false
    }))
  }

  toggleWideView = () => {
    this.setState(
      prevState => ({
        ...this.state,
        isWideView: !prevState.isWideView
      }),
      () => {
        this.onHideTextModal()
      }
    )
  }

  handleSubmitSummarise = (e, param) => {
    e.preventDefault()
    const {
      summariseResult,
      summariseResultOptionOne,
      ai_language
    } = this.state
    this.props.form.validateFields((err, values) => {
      if (!err) {
        console.log('Received values of form2: ', values)
        this.setState({
          ...this.state,
          idx: param.idx
        })

        const dataT1 = {
          content: param.context,
          max_length: values.num_words,
          min_length: 30,
          lang: ai_language || 'en-US'
        }

        const dataT = {
          text: param.context,
          num_words: values.num_words,
          num_keywords: 30
        }
        // Option 1
        api.summarization
          .getSummarized(dataT1, 'abstractive')
          .then(res => {
            let data = res.data
            let dataToUpdate = summariseResultOptionOne

            const isDataAlreadyExist =
              dataToUpdate && dataToUpdate.some(data => data.id === param.idx)
            if (!isDataAlreadyExist) {
              dataToUpdate = [
                ...dataToUpdate,
                {
                  id: param.idx,
                  data: data.output
                }
              ]
            }
            const fetchIndexOfExistingData = dataToUpdate.findIndex(
              data => data.id === param.idx
            )
            if (fetchIndexOfExistingData !== -1) {
              dataToUpdate[fetchIndexOfExistingData] = {
                id: dataToUpdate[fetchIndexOfExistingData].id,
                data: data.output
              }
            }
            let newTabIndex = this.state.tabIndex
            newTabIndex[param.idx] = '3'
            this.setState({
              ...this.state,
              summariseResultOptionOne: dataToUpdate,
              loadSummarize: false,
              errorMsg: '',
              tabIndex: newTabIndex
            })
          })
          .catch(err => {
            this.setState({
              loadSummarize: false,
              errorMsg:
                err.error && err.error.msg
                  ? err.error.msg
                  : 'Something went wrong.'
            })
          })

        // Option 2
        this.setState({ loadSummarize: true, errorMsg: '' }, () => {
          api.summarization
            .getSummarized(dataT, 'extractive')
            .then(response => {
              let data = response.data
              let dataToUpdate = summariseResult
              console.log('get data', data.summary)
              const isDataAlreadyExist =
                dataToUpdate && dataToUpdate.some(data => data.id === param.idx)
              if (!isDataAlreadyExist) {
                dataToUpdate = [
                  ...dataToUpdate,
                  {
                    id: param.idx,
                    data: data.summary
                  }
                ]
              }
              const fetchIndexOfExistingData = dataToUpdate.findIndex(
                data => data.id === param.idx
              )
              if (fetchIndexOfExistingData !== -1) {
                dataToUpdate[fetchIndexOfExistingData] = {
                  id: dataToUpdate[fetchIndexOfExistingData].id,
                  data: data.summary
                }
              }
              console.log(
                'final data',
                data.summary,
                'summaryData',
                dataToUpdate
              )
              let newTabIndex = this.state.tabIndex
              newTabIndex[param.idx] = '3'
              this.setState({
                ...this.state,
                summariseResult: dataToUpdate,
                loadSummarize: false,
                errorMsg: '',
                tabIndex: newTabIndex
              })
            })
            .catch(e => {
              console.log(e)
              this.setState({
                loadSummarize: false,
                errorMsg:
                  e.error && e.error.msg ? e.error.msg : 'Something went wrong.'
              })
            })
        })
      }
    })
  }

  // handleSubmitSummarise = (e, param) => {
  //   e.preventDefault()
  //   const { summariseResult } = this.state
  //   this.props.form.validateFields((err, values) => {
  //     if (!err) {
  //       console.log('Received values of form2: ', values)
  //       this.setState({
  //         ...this.state,
  //         idx: param.idx

  //       })

  //       const dataT = {
  //         text: param.context,
  //         num_words: values.num_words,
  //         num_keywords: 35
  //       }

  //       const testURL = config.summarizeURL
  //       const myInit = {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json'
  //         },
  //         body: JSON.stringify(dataT)
  //       }

  //       const myRequest = new Request(testURL, myInit)
  //       this.setState({ loadSummarize: true, errorMsg: '' }, () => {
  //         fetch(myRequest)
  //           .then(response => {
  //             console.log(
  //               'response question summarisation',
  //               response.body,
  //               'data summary inside',
  //               summariseResult,
  //               'param.idx',
  //               param.idx
  //             )
  //             return response.json()
  //           })
  //           .then(data => {
  //             let dataToUpdate = summariseResult
  //             console.log('get data', data.summary)

  //             const isDataAlreadyExist =
  //               dataToUpdate && dataToUpdate.some(data => data.id === param.idx)
  //             if (!isDataAlreadyExist) {
  //               dataToUpdate = [
  //                 ...dataToUpdate,
  //                 {
  //                   id: param.idx,
  //                   data: data.summary
  //                 }
  //               ]
  //             }
  //             const fetchIndexOfExistingData = dataToUpdate.findIndex(
  //               data => data.id === param.idx
  //             )

  //             if (fetchIndexOfExistingData !== -1) {
  //               dataToUpdate[fetchIndexOfExistingData] = {
  //                 id: dataToUpdate[fetchIndexOfExistingData].id,
  //                 data: data.summary
  //               }
  //             }

  //             console.log(
  //               'final data',
  //               data.summary,
  //               'summaryData',
  //               dataToUpdate
  //             )
  //             this.setState({
  //               ...this.state,
  //               summariseResult: dataToUpdate,
  //               loadSummarize: false,
  //               errorMsg: ''
  //             })
  //           })
  //           .catch(e => {
  //             console.log(e)
  //             this.setState({
  //               loadSummarize: false,
  //               errorMsg:
  //                 e.error && e.error.msg ? e.error.msg : 'Something went wrong.'
  //             })
  //           })
  //       })
  //     }
  //   })
  // }

  render() {
    const {
      t,
      audioSynthesizer: { isProcessing },
      pageBuilder: { isShowTextModal },
      getLibraryList,
      getPublicList,
      getOrgList,
      clearUploadList,
      updateLibraryStatus,
      updateOrgLib,
      handleMakeType,
      library,
      user,
      topics,
      updateTopicList,
      upload
    } = this.props

    const { getFieldDecorator } = this.props.form
    const {
      src,
      voiceList,
      selectedText,
      selectedVoice,
      languages,
      languageValue,
      filteredList,
      isInsertText,
      selectedTextViewer,
      isWideView,
      isLoading,
      showSearchResult,
      hasInitialize,
      sampleSrc
    } = this.state

    console.log(
      'state in audio',
      sampleSrc,
      'src',
      src,
      'selectedtxt',
      selectedText
    )

    let allList = []
    let maleList = []
    let femaleList = []
    let neuralList = []
    if (_.isEmpty(languageValue)) {
      allList = voiceList
      maleList = voiceList.filter(m => m[1].gender === 'Male')
      femaleList = voiceList.filter(f => f[1].gender === 'Female')
      neuralList = voiceList.filter(n => !!n[1].neural)
    } else {
      allList = filteredList
      maleList = filteredList.filter(m => m[1].gender === 'Male')
      femaleList = filteredList.filter(f => f[1].gender === 'Female')
      neuralList = filteredList.filter(n => !!n[1].neural)
    }
    const textIcon = (
      <div className="toolbar__item-icon" style={styleTitle}>
        <div className="wrap-video-icons">
          <img src={textIconRectangle} alt="" />{' '}
          <span style={{ color: '#67686C' }}> {t('v4:insert_text')} </span>
          <img
            src={textIconInsideRectangle}
            alt=""
            className="text-icon-inside-rectangle"
          />
        </div>
      </div>
    )

    const summariseConfirm = param => (
      <div className="sum_form">
        <p>*{t('v2:enter_number_words')}:</p>
        <Form onSubmit={e => this.handleSubmitSummarise(e, param)}>
          <Form.Item layout="inline" style={{ marginBottom: '10px' }}>
            {getFieldDecorator('num_words', {
              initialValue: 100,
              rules: [{ required: true, message: t('v2:enter_number_words') }]
            })(<InputNumber min={100} />)}
          </Form.Item>
          <Button type="primary" shape="round" htmlType="submit">
            {t('v2:summarize')}
          </Button>
        </Form>
      </div>
    )

    const titleSearch = (answer, context, idx) => {
      return (
        <p>
          <strong>Answer </strong>
          <Popover content={summariseConfirm({ context: context, idx: idx })}>
            <h2
              style={{
                float: 'right',
                color: 'blue',
                textDecorationLine: 'underline'
              }}
              type="primary"
            >
              {t('v2:summarize')}
            </h2>
          </Popover>
        </p>
      )
    }

    const searchResult =
      showSearchResult &&
      this.state.resultData &&
      this.state.resultData.map((data, idx) => {
        const showSummary = this.state.summariseResult.filter(s => s.id === idx)
        const showSummary1 = this.state.summariseResultOptionOne.filter(
          s => s.id === idx
        )
        console.log('in list', showSummary, 'main idx', idx)
        return (
          <Fragment>
            &nbsp;
            <Card
              size="small"
              title={titleSearch(data.answer, data.context, idx)}
              style={{ width: '100%' }}
            >
              <Tabs defaultActiveKey="1" onChange={this.onChangeTab}>
                <TabPane tab="Answer" key="1">
                  <p>{data.answer}</p>
                </TabPane>
                <TabPane tab="Context" key="2">
                  <p>{data.context}</p>
                </TabPane>
                <TabPane tab="Summarised" key="3">
                  {this.state.loadSummarize ? (
                    'Processing...'
                  ) : this.state.errorMsg === '' ? (
                    <>
                      {showSummary1[0] ||
                        (showSummary[0] && (
                          <div className="sum__ans">
                            <div className="sum__ans_item">
                              <p>{t('v2:option_1')}</p>
                              {showSummary1[0] && showSummary1[0].data}
                            </div>
                            <div className="sum__ans_item">
                              <p>{t('v2:option_2')}</p>
                              {showSummary[0] && showSummary[0].data}
                            </div>
                          </div>
                        ))}
                    </>
                  ) : (
                    this.state.errorMsg
                  )}
                </TabPane>
              </Tabs>
            </Card>
            &nbsp;
          </Fragment>
        )
      })

    return (
      <Fragment>
        <Modal
          className="custom-ant-modal"
          title={textIcon}
          visible={isShowTextModal}
          onCancel={this.onHideTextModal}
          width={'85%'}
          footer={[
            <Button
              type="default"
              shape="round"
              size="default"
              className="ant-btn rounded"
              onClick={this.onHideTextModal}
            >
              {t('buttons:cancel')}
            </Button>,
            <Button
              type="primary"
              shape="round"
              size="default"
              className="ant-btn rounded ant-btn-primary"
              onClick={this.handleInsertText}
            >
              {t('buttons:insert')}
            </Button>
          ]}
        >
          <TextLibrary
            isInsertText={isInsertText}
            getLibraryList={getLibraryList}
            getPublicList={getPublicList}
            getOrgList={getOrgList}
            upload={upload}
            clearUploadList={clearUploadList}
            updateLibraryStatus={updateLibraryStatus}
            updateOrgLib={updateOrgLib}
            handleMakeType={handleMakeType}
            library={library}
            user={user}
            topics={topics}
            updateTopicList={updateTopicList}
            showValue={selectedTextViewer}
            showText={this.showText}
          />
        </Modal>
        <div className="bg-modal">
          {!isWideView && (
            <Row gutter={24}>
              <Col span={16}>
                <span>
                  <Select
                    showSearch
                    style={{ width: '200px' }}
                    placeholder={t('v4:translate_to')}
                    optionFilterProp="children"
                    onChange={e => this.handleChangeOption(e)}
                  >
                    {translationKeys.map(item => (
                      <Option key={item.code} value={item.code}>
                        {/* <Flag code={item.code} height='13' /> */}{' '}
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                  &nbsp;&nbsp;
                  <Button
                    className="rounded"
                    size="large"
                    onClick={this.handleClickImportText}
                  >
                    {t('v4:import_from_library')}
                  </Button>
                  &nbsp;&nbsp;
                  {this.props.user &&
                    this.props.user.info &&
                    this.props.user.info.organization &&
                    this.props.user.info.organization.enable_ai && (
                      <Button
                        className="rounded"
                        type="dashed"
                        size="large"
                        onClick={this.handleClickQAText}
                      >
                        {t('v4:question_answer_ai')}
                      </Button>
                    )}
                </span>

                <div className="textarea-warp">
                  <TextArea
                    disabled={!!isProcessing}
                    value={selectedText}
                    onChange={this.onChangeText}
                    placeholder={t('audio:type_something')}
                    autoSize={{ minRows: 25, maxRows: 25 }}
                  />

                  <div
                    className={isSafari ? 'audio-warp-safari' : 'audio-warp'}
                  >
                    {/* {_.isEmpty(src) && <AudioPlayer src='' autoPlay={autoPlay} />}{' '} */}
                    {!_.isEmpty(src) ? (
                      <AudioPlayer src={src} autoPlay={true} />
                    ) : (
                      <AudioPlayer src="" autoPlay={false} />
                    )}
                    <Button
                      type="submit"
                      shape="round"
                      size="default"
                      disabled={
                        _.isEmpty(selectedText) ||
                        _.isEmpty(selectedVoice) ||
                        isProcessing
                      }
                      className="button-create btn-success"
                      onClick={() => this.onClickButton()}
                    >
                      {isProcessing
                        ? t('media:processing_audio')
                        : !_.isEmpty(src)
                        ? t('v4:publish')
                        : t('media:create')}
                    </Button>
                  </div>
                </div>
              </Col>
              <Col span={8} className={'audio-tab'}>
                <Row>
                  <Col span={12}>
                    {/* <h3>{t('audio:select_voice')}</h3> */}
                    <Autocomplete
                      getItemValue={item => item}
                      shouldItemRender={(item, value) =>
                        item.toLowerCase().indexOf(value.toLowerCase()) > -1
                      }
                      items={languages}
                      renderItem={(item, isHighlighted) => (
                        <div
                          style={
                            isHighlighted ? styles.HighLight : styles.NormalText
                          }
                        >
                          {item}
                        </div>
                      )}
                      inputProps={{ placeholder: 'Select language' }}
                      wrapperStyle={styles.AutoWrappper}
                      menuStyle={styles.autoCompleteModal}
                      value={languageValue}
                      onChange={e => this.onLanguageSearch(e.target.value)}
                      onSelect={(val, item) => this.onLanguageSelect(item)}
                    />
                  </Col>
                </Row>
                <Tabs animated={false}>
                  <TabPane
                    tab={t('media:all')}
                    disabled={selectedTextViewer !== ''}
                    key="1"
                  >
                    {selectedTextViewer !== '' && (
                      <Fragment>
                        <span style={{ marginLeft: '25em' }}>
                          <CloseOutlined onClick={this.onCloseTextViewer} />
                        </span>
                        <TextArea
                          value={selectedTextViewer}
                          autoSize={{ rows: 24 }}
                        />
                      </Fragment>
                    )}
                    {selectedTextViewer === '' && (
                      <div
                        style={{
                          height: '520px',
                          overflowY: 'scroll',
                          width: '375px'
                        }}
                      >
                        <Row gutter={24}>
                          <List
                            itemLayout="horizontal"
                            dataSource={allList}
                            renderItem={item => (
                              <List.Item
                                actions={[
                                  <span
                                    style={{
                                      color: '#1890ff',
                                      cursor: 'pointer'
                                    }}
                                    key="list-loadmore-edit"
                                    role="button"
                                    tabIndex="0"
                                  >
                                    <Tooltip title="Preview">
                                      {item && item[1].sample !== '' && (
                                        <PlayCircleOutlined
                                          onClick={() =>
                                            this.onClickPreviewIcon(item)
                                          }
                                        />
                                      )}
                                    </Tooltip>
                                  </span>
                                ]}
                              >
                                <List.Item.Meta
                                  avatar={
                                    <Avatar
                                      src={
                                        selectedVoice === item[0]
                                          ? activateSoundIcon
                                          : deactiveSoundIcon
                                      }
                                    />
                                  }
                                  style={{
                                    cursor: 'pointer'
                                  }}
                                  onClick={() => this.onClickCard(item)}
                                  title={`${item[0]}.mp3`}
                                />
                              </List.Item>
                            )}
                          />
                        </Row>
                      </div>
                    )}
                  </TabPane>
                  <TabPane
                    tab={t('media:male')}
                    disabled={selectedTextViewer !== ''}
                    key="2"
                  >
                    <div
                      style={{
                        height: '520px',
                        overflowY: 'scroll',
                        width: '386px'
                      }}
                    >
                      <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 20]}>
                        <List
                          itemLayout="horizontal"
                          dataSource={maleList}
                          renderItem={item => (
                            <List.Item
                              actions={[
                                <span
                                  style={{
                                    color: '#1890ff',
                                    cursor: 'pointer'
                                  }}
                                  key="list-loadmore-edit"
                                  role="button"
                                  tabIndex="0"
                                >
                                  <Tooltip title="Preview">
                                    {item && item[1].sample !== '' && (
                                      <PlayCircleOutlined
                                        onClick={() =>
                                          this.onClickPreviewIcon(item)
                                        }
                                      />
                                    )}
                                  </Tooltip>
                                </span>
                              ]}
                            >
                              <List.Item.Meta
                                avatar={
                                  <Avatar
                                    src={
                                      selectedVoice === item[0]
                                        ? activateSoundIcon
                                        : deactiveSoundIcon
                                    }
                                  />
                                }
                                style={{
                                  cursor: 'pointer'
                                }}
                                onClick={() => this.onClickCard(item)}
                                title={`${item[0]}.mp3`}
                              />
                            </List.Item>
                          )}
                        />
                      </Row>
                    </div>
                  </TabPane>
                  <TabPane
                    tab={t('media:female')}
                    disabled={selectedTextViewer !== ''}
                    key="3"
                  >
                    <div
                      style={{
                        height: '520px',
                        overflowY: 'scroll',
                        width: '386px'
                      }}
                    >
                      <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 20]}>
                        <List
                          itemLayout="horizontal"
                          dataSource={femaleList}
                          renderItem={item => (
                            <List.Item
                              actions={[
                                <span
                                  style={{
                                    color: '#1890ff',
                                    cursor: 'pointer'
                                  }}
                                  key="list-loadmore-edit"
                                  role="button"
                                  tabIndex="0"
                                >
                                  <Tooltip title="Preview">
                                    {item && item[1].sample !== '' && (
                                      <PlayCircleOutlined
                                        onClick={() =>
                                          this.onClickPreviewIcon(item)
                                        }
                                      />
                                    )}
                                  </Tooltip>
                                </span>
                              ]}
                            >
                              <List.Item.Meta
                                avatar={
                                  <Avatar
                                    src={
                                      selectedVoice === item[0]
                                        ? activateSoundIcon
                                        : deactiveSoundIcon
                                    }
                                  />
                                }
                                style={{
                                  cursor: 'pointer'
                                }}
                                onClick={() => this.onClickCard(item)}
                                title={`${item[0]}.mp3`}
                              />
                            </List.Item>
                          )}
                        />
                      </Row>
                    </div>
                  </TabPane>
                  <TabPane
                    tab={t('v4:human')}
                    disabled={selectedTextViewer !== ''}
                    key="4"
                  >
                    <div
                      style={{
                        height: '520px',
                        overflowY: 'scroll',
                        width: '386px'
                      }}
                    >
                      <List
                        itemLayout="horizontal"
                        dataSource={neuralList}
                        renderItem={item => (
                          <List.Item
                            actions={[
                              <span
                                style={{ color: '#1890ff', cursor: 'pointer' }}
                                key="list-loadmore-edit"
                                role="button"
                                tabIndex="0"
                              >
                                <Tooltip title="Preview">
                                  {item && item[1].sample !== '' && (
                                    <PlayCircleOutlined
                                      onClick={() =>
                                        this.onClickPreviewIcon(item)
                                      }
                                    />
                                  )}
                                </Tooltip>
                              </span>
                            ]}
                          >
                            <List.Item.Meta
                              avatar={
                                <Avatar
                                  src={
                                    selectedVoice === item[0]
                                      ? activateSoundIcon
                                      : deactiveSoundIcon
                                  }
                                />
                              }
                              style={{
                                cursor: 'pointer'
                              }}
                              onClick={() => this.onClickCard(item)}
                              title={`${item[0]}.mp3`}
                            />
                          </List.Item>
                        )}
                      />
                    </div>
                  </TabPane>
                </Tabs>
                <div className={isSafari ? 'audio-warp-safari' : 'audio-warp'}>
                  {!_.isEmpty(sampleSrc) ? (
                    <AudioPlayer src={sampleSrc} autoPlay={true} />
                  ) : (
                    <AudioPlayer src="" autoPlay={false} />
                  )}
                </div>
              </Col>
            </Row>
          )}
          {isWideView && (
            <Row>
              <span>
                <Select
                  showSearch
                  style={{ width: '200px' }}
                  placeholder={t('v4:translate_to')}
                  optionFilterProp="children"
                  onChange={e => this.handleChangeOption(e)}
                >
                  {translationKeys.map(item => (
                    <Option key={item.code} value={item.code}>
                      {/* <Flag code={item.code} height='13' /> */} {item.name}
                    </Option>
                  ))}
                </Select>
                &nbsp;&nbsp;
                <Button
                  className="rounded"
                  size="large"
                  onClick={this.handleClickImportText}
                >
                  {t('v4:import_from_library')}
                </Button>
                &nbsp;&nbsp;
                {this.props.user &&
                  this.props.user.info &&
                  this.props.user.info.organization &&
                  this.props.user.info.organization.enable_ai && (
                    <Button
                      className="rounded"
                      type="dashed"
                      size="large"
                      onClick={this.handleClickQAText}
                    >
                      {t('v4:question_answer_ai')}
                    </Button>
                  )}
              </span>
              {!hasInitialize ? (
                <Col span={12}>
                  &nbsp; &nbsp;
                  <div>{t('v2:hold_tight_one_minute')}</div>
                </Col>
              ) : (
                <Col span={12}>
                  &nbsp; &nbsp;
                  <Form onSubmit={this.handleSubmit}>
                    <Form.Item
                      label={t('v2:enter_question')}
                      style={{ marginBottom: '7px' }}
                    >
                      {getFieldDecorator('question', {
                        rules: [
                          {
                            required: true,
                            message: t('v4:input_your_question')
                          }
                        ]
                      })(<Input placeholder={t('v4:make_me_sales_manager')} />)}
                    </Form.Item>
                    <Form.Item
                      label={t('v4:enter_the_number_relevant_document')}
                      style={{ marginBottom: '10px' }}
                    >
                      {getFieldDecorator('no_of_documents', {
                        initialValue: 2,
                        rules: [
                          {
                            required: true,
                            message: t('v2:please_input_relevant_documents')
                          }
                        ]
                      })(<InputNumber min={1} max={20} />)}
                    </Form.Item>
                    <Button
                      type="primary"
                      icon="search"
                      shape="round"
                      htmlType="submit"
                    >
                      {t('v2:search')}
                    </Button>
                  </Form>
                  &nbsp; &nbsp;
                  {isLoading && <h2>{t('v4:please_wait_loading_result')}</h2>}
                  {showSearchResult && !isLoading && (
                    <Fragment>
                      &nbsp; &nbsp;
                      {this.state.resultData.length > 0 ? (
                        <h2>Results({this.state.resultData.length})</h2>
                      ) : (
                        <h2>{t('v4:no_result_found')}</h2>
                      )}
                      <div className="result-relevant-answers">
                        {searchResult}
                      </div>
                    </Fragment>
                  )}
                </Col>
              )}
              <Col span={11} offset={1}>
                <Button
                  style={{ float: 'right', top: '-2em' }}
                  className="rounded"
                  type="primary"
                  size="large"
                  onClick={this.toggleWideView}
                >
                  {t('v2:proceed_to_add_voice')}
                </Button>
                <div className="textarea-warp">
                  <TextArea
                    disabled={!!isProcessing}
                    value={selectedText}
                    onChange={this.onChangeText}
                    placeholder={t('audio:type_something')}
                    autoSize={{ minRows: 25, maxRows: 25 }}
                  />
                </div>
              </Col>
            </Row>
          )}
        </div>
      </Fragment>
    )
  }
}

const WrappedCreateAudio = Form.create({ name: 'text_form' })(CreateAudio)

export default withTranslation('')(WrappedCreateAudio)
